import axios from 'axios'
export default {
  name: 'Enviarbiblioteca',
  components: { },
  data () {
    return {
      errores: [], pedido: []
    }
  },
  props:['pedidolocal'],
  mounted () {
    this.cargarpedido()
  },
  methods: {
    listapedidos (lista) {
      return _.orderBy(lista, ['id'], ['desc'])
    },
    volveratras () {
      this.$router.push('/listador')
    },
    enviarbiblioteca (categoria, pedido) {
      axios.post(this.$apibase+'gen/enviarbiblioteca', {
        "categoria": categoria, "pedido": pedido, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
      })
      .then( response => this.pasoenviar(response),  response => this.errorenviar(response) )
      .catch( response => this.errorenviar(response))
    },
    pasoenviar (response) {
      if (response.data.estado === 1) {
        var url = '/categoria/'+response.data.categoria.slug+'/1'
        this.$router.push(url) 
      }
    },
    errorenviar (response) {

    },
    cargarpedido () {
      var conditionArr = [parseInt(this.pedidolocal)]
      var result = _.filter(this.$store.getters.pedidos, (v) => _.includes(conditionArr, v.id))
      this.pedido = result[0]
      return result;
    },
    cargarcategorias () {
      if (this.$store.getters.islogin === true){
          axios.get(this.$apibase+'gen/biblioteca/', {
            params: {
              'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
            }
          })
          .then( response => this.procesarcategorias(response),  response => this.errorprocesarcategorias(response) )
          .catch( response => this.errorprocesarcategorias(response))
      } else {
        errorprocesarcategorias ('notcred')
      }
    },
    procesarcategorias (response) {
      if(response.data.estado === 1){
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias)
      }
    },
    errorprocesarcategorias (response){
    }
  },
  computed: {
    categorias () {
      var act = _.orderBy(this.$store.getters.categorias, ['id'], ['desc'])
      if (_.isEmpty(act)) {
        console.log('vacio')
        this.cargarcategorias()
        return null
      }
      return act
    },
    nombrematerial () {
      if (this.pedido.material == 2) {
        return 'Melamínico Otro MDF 18mm 2600x1830'
      } else if (this.pedido.material == 3) {
        return 'Melamínico Otro MDF 18mm 2750x1830'
      } else {
        return 'Melamínico Blanco MDF 18mm 2600x1830'
      }
    },
    colorplaca () {
      if (this.pedido.material >= 2) {
        return 'Color: '+this.pedido.colorplaca
      }
    },
    colorcanto () {
      if (this.pedido.material >= 2) {
        return 'Color: '+this.pedido.colorcanto
      }
    },
    nombrecanto () {
      if (this.pedido.material == 1) {
        return 'ABS Blanco'
      } else {
        return 'ABS Otro'
      }
    }
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/enviarbiblioteca.js